import { render, staticRenderFns } from "./IkasSelectOrder.vue?vue&type=template&id=2ae9af54"
import script from "./IkasSelectOrder.vue?vue&type=script&lang=js"
export * from "./IkasSelectOrder.vue?vue&type=script&lang=js"
import style0 from "./IkasSelectOrder.vue?vue&type=style&index=0&id=2ae9af54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports